import axios from 'axios';

// Eigene Instanz ohne withCredentials/401-Redirect: die öffentliche Seite hat
// keine Session, ein 401 an anderer Stelle darf hier niemanden zum Login
// weiterleiten.
const publicApi = axios.create({
  baseURL: '/api/public',
  headers: {
    'Content-Type': 'application/json',
  },
});

export default publicApi;
